import { Outlet, useLocation } from 'react-router-dom';
import { useReconcilePortalPaymentSettlement } from '@/hooks/useReconcilePortalPaymentSettlement';
import { PortalActiveClinicProvider } from '@/lib/portalActiveClinic';
import { PortalFooter, PortalTabBar, PortalTopBar } from '@/components/portal/PortalChrome';

/**
 * Patient portal shell: desktop top bar + mobile bottom bar.
 */
export function PortalLayout() {
  useReconcilePortalPaymentSettlement();
  const { pathname } = useLocation();
  const wide = pathname === '/portal/dashboard' || pathname.startsWith('/portal/messages');

  return (
    <PortalActiveClinicProvider>
      <div className="pt">
        <a className="skip" href="#main">
          Spring til indhold
        </a>
        <PortalTopBar />
        <main id="main" className={wide ? 'pt-main' : 'pt-main narrow'}>
          <Outlet />
        </main>
        <PortalFooter />
        <PortalTabBar />
      </div>
    </PortalActiveClinicProvider>
  );
}
